export const RolesActionTypes = {
  API_RESPONSE_SUCCESS: '@@roles/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@roles/API_RESPONSE_ERROR',

  GET_ROLE: '@@roles/GET_ROLE',
  GET_ROLE_TOPBAR: '@@roles/GET_ROLE_TOPBAR',
  LIST_ROLES: '@@roles/LIST_ROLES',
  ADD_ROLE: '@@roles/ADD_ROLE',
  UPDATE_ROLE: '@@roles/UPDATE_ROLE',
  DELETE_ROLE: '@@roles/DELETE_ROLE',

  RESET: '@@roles/RESET'
}
